export default __webpack_public_path__ + "static/media/TITAN-MATIC.1f0af2ed.png";